import useFacilityData from "../hooks/useFacilityData.ts"

export default () => {
  const data = useFacilityData()

  const facilityData = data.sanityFacility

  const gallery = facilityData.facilityObj.gallery

  const vidGallery = facilityData.facilityObj.videoGallery

  return gallery.length > 0 || vidGallery.length > 0
}
